import classNames from 'classnames/bind'
import styles from './EFLoading.module.scss'

const cx = classNames.bind(styles)

export const Spinner = () => {
  return <span className={cx('spinner')}></span>
}
